import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MY_CUSTOMER: AppRouteRecordRaw = {
  path: '/my-customer',
  name: 'my-customer',
  component: DEFAULT_LAYOUT,
  redirect: '/my-customer/list',
  meta: {
    locale: 'menu.myCustomer',
    requiresAuth: true,
    icon: 'icon-user',
    order: 2,
    hideChildrenInMenu: true,
    activeMenu: 'my-customer',
  },
  children: [
    {
      path: 'list',
      name: 'MyCustomer',
      component: () => import('@/views/customer/myCustomer.vue'),
      meta: {
        locale: 'menu.myCustomer',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default MY_CUSTOMER;
